import { Edge, Node } from "@xyflow/react";
import { atom } from "recoil";

import { NodeFormData } from "../utils/nodeDefaults";

export interface SelectedNodeData {
    id: string;
    type: string;
    formData?: NodeFormData;
}

export interface SelectedEdgeData {
    id: string;
    source: string;
    target: string;
    data?: Record<string, unknown>;
}

export const ccNodesAtom = atom<Node[]>({
    key: "ccNodes",
    default: [],
});

export const ccEdgesAtom = atom<Edge[]>({
    key: "ccEdges",
    default: [],
});

export const ccSelectedNodeAtom = atom<SelectedNodeData | null>({
    key: "ccSelectedNode",
    default: null,
});

export const ccSelectedEdgeAtom = atom<SelectedEdgeData | null>({
    key: "ccSelectedEdge",
    default: null,
});
